import { Button } from '@usitsdasdesign/dds-react'
import Text from 'atoms/Text'
import AsyncReactSelectPaginate from 'molecules/AsyncReactSelectPaginate'
import React, { useState, useEffect } from 'react'

const RenderUser = ({ data }) => {
    return (
        <div className={`p-1.5`} >
            <div className='flex gap-1 items-center'>
                <Text>{data.name}</Text>
                <Text variant='label' className='text-gray-900'> ({data.employeeCode})</Text>
            </div>
            <Text variant='label' className='text-gray-900'>
                {data.designation} | {data.email} | {data.subServiceArea}
            </Text>
        </div>
    );
};

function AddUsers({
    title = 'Approvers',
    helpertext = "",
    isRequired = true,
    control,
    register = () => false,
    name = 'name',
    defaultValue,
    className = '',
    values = [],
    setValue = () => false,
    isError,
    errorMessage,
    setError,
    clearErrors,
    max = 3,
    ...rest
}) {

    const [isErrors, setIsErrors] = useState(false);
    const [errorMessages, setErrorMessages] = useState('');
    const [showSelector, setShowSelector] = useState(false);
    const [index, setIndex] = useState(null);
    const [storage, setStorage] = useState([]);
    const [hasMaster, setHasMaster] = useState(false);
    const [masterTemp, setMasterTemp] = useState(false);
    const handleAddApprover = (item) => {
        if (item === null) return;
        let updatedValues;
        if (hasMaster || masterTemp) {
            updatedValues = item.map((ite) => ite?.isMaster && ite.approverNo ? ite : ite.approverNo ? ite : { ...ite, approverNo: item?.length, isMaster: false }).sort((a, b) => a.approverNo - b.approverNo);
        } else {
            updatedValues = item.map((ite) => !(ite?.isMaster && ite.approverNo) ? { ...ite, approverNo: 1, isMaster: false } : ite).sort((a, b) => a.approverNo - b.approverNo);
        }
        setValue(name, updatedValues, { shouldDirty: true, shouldValidate: true });
        setShowSelector(false);
    }


    useEffect(() => {
        const hasExactlyOneMaster = values.filter((val) => val.isMaster === true).length === 1;
        setHasMaster(hasExactlyOneMaster);
        if ((storage?.length && (values?.length === 1)) && masterTemp) {
            const firstApprover = values[0];
            const updatedValues = [firstApprover, ...storage.slice(1)];
            setValue(name, updatedValues, { shouldDirty: true, shouldValidate: true });
            setStorage([]);
            setIndex(null);
            setMasterTemp(false);
        }
    }, [values]);


    return (
        <div className={className}>
            <div className='flex items-center gap-2 justify-between mb-2'>
                <div>
                    <Text variant='labelSemibold'>{title} {isRequired && <span className='text-red-900'>*</span>}</Text>
                    {helpertext && <Text variant='label' className='text-gray-1100 mt-1.5'>{helpertext}</Text>}
                </div>
                <Button
                    label='Add'
                    icon='plus__s__stroke'
                    size='m'
                    kind='silent'
                    onClick={() => setShowSelector(true)}
                    isDisabled={values.length >= max}
                />
            </div>

            {
                showSelector ? (
                    <AsyncReactSelectPaginate
                        control={control}
                        register={register}
                        onChange={handleAddApprover}
                        name={name}
                        defaultValue={defaultValue}
                        menuIsOpen
                        hideSelectedOptions={true}
                        className='add-user-dropdown'
                        isClearable={false}
                        backspaceRemovesValue={false}
                        {...rest}
                    />
                ) : (
                    values.length === 0 && <Text className='text-gray-900'>No Approvers added</Text>
                )
            }

            {
                values.length > 0 && (
                    <div className='mb-4'>
                        {
                            values.map((item, i) => {
                                return (
                                    <div key={i} className='flex items-center justify-between gap-4 border-b border-gray-200'>
                                        <div className='flex items-center gap-4 flex-1'>
                                            <Text variant='label' className='flex-none'>
                                                Approver level {!(item?.approverNo && item?.isMaster) ? i + 1 : item.approverNo}</Text>
                                            <RenderUser data={item} />
                                        </div>
                                        {!item?.isMaster && <Button
                                            icon='delete__s__stroke'
                                            className='flex-none'
                                            kind='silent'
                                            onClick={() => {
                                                if (!(values?.length === item?.approverNo)) {
                                                    if (hasMaster) {
                                                        setIndex(i);
                                                        setStorage(values);
                                                        setValue(name, [])
                                                        setMasterTemp(hasMaster);
                                                    } else {
                                                        const updated = values.filter(i => i !== item)
                                                        setValue(name, updated)
                                                    }
                                                } else {
                                                    const updated = values.filter(i => i !== item)
                                                    setValue(name, updated)
                                                }
                                            }}
                                        />}
                                    </div>
                                )
                            })
                        }

                    </div>
                )
            }
            {
                ((storage.length > 0) && !index) && (
                    <div className='mb-4'>
                        {
                            storage.filter((_, ind) => ind !== index).map((item, i) => {
                                return (
                                    <div key={i} className='flex items-center justify-between gap-4 border-b border-gray-200'>
                                        <div className='flex items-center gap-4 flex-1'>
                                            <Text variant='label' className='flex-none'>
                                                Approver level {item.approverNo}</Text>
                                            <RenderUser data={item} />
                                        </div>
                                        {!item?.isMaster && <Button
                                            icon='delete__s__stroke'
                                            className='flex-none'
                                            kind='silent'
                                            onClick={() => {
                                                isError = true
                                                errorMessage = 'Add removed Approver First'
                                                setIsErrors(true);
                                                setErrorMessages('Add removed Approver First');
                                                setTimeout(() => {
                                                    setIsErrors(false);
                                                    setErrorMessages(undefined);
                                                }, 2000);

                                            }}
                                        />}
                                    </div>
                                )
                            })
                        }

                    </div>
                )
            }
            {isErrors && <div className="text-red-900 text-[12px] pt-1 error-in-field">{errorMessages}</div>}
            {isError && <div className="text-red-900 text-[12px] pt-1 error-in-field">{errorMessage}</div>}

        </div>
    )
}

export default AddUsers